"use client";

import { Feedback } from "@/components/feedback";
import { useStore } from "@/contexts/store";
import { share } from "../../_utils/share";
import { storeAnalitica } from "@/app/(store)/_utils/events";
import { useEffectOnce } from "@/hooks/use-effect-once";
import { Container } from "@/components/container";
import { MessageBuilder } from "@/utils/message-builder";
import { useExperiment } from "@/contexts/analitica";
import { ExperimentsFlags } from "@/services/amplitude/experiment";

const EmptyStore = () => {
  const { store, enabledWhatsAppSharing } = useStore();
  const showCartExperiment = useExperiment(ExperimentsFlags.ShowCart);
  const action = enabledWhatsAppSharing
    ? {
        action: {
          text: "Conversar com a loja",
          variant: "primary-solid" as const,
          icon: "brand-whatsapp" as const,
          onClick: () => {
            storeAnalitica.events.action.emptyWhatsappClicked();

            share.whatsapp(
              store.vitrine.whatsAppNumber,
              MessageBuilder.buildCatalogGreeting(store.name, showCartExperiment)
            );
          },
        },
      }
    : {};

  useEffectOnce(() => {
    storeAnalitica.events.view.empty();
  });

  return (
    <Container className="flex min-h-[calc(100vh-232px)] flex-col xl:min-h-[calc(100vh-276px)]">
      <Feedback
        id="empty-store"
        icon="shop"
        title="Ainda não há produtos neste catálogo"
        message={`${store.name} deve estar preparando algo especial. Volte em breve!`}
        {...action}
      />
    </Container>
  );
};

export { EmptyStore };
